import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import blue from './blue.png';
import yellow from './yellow.png';
import green from './green.png';
import * as API from "../Endpoints/Endpoints"
import { useLocation, useNavigate } from "react-router-dom";

const ChakraShow = () => {
  const [showButtons, setShowButtons] = useState(false);
  const [vajraName, setVajraName] = useState('');
  const [spokeName, setSpokeName] = useState('');
  const [bladeNames, setBladeNames] = useState([]);
  const chakraRef = useRef(null);
  const [vajraAnswer, setVajraAnswer] = useState("");
  const [vajraScore, setVajraScore] = useState("");
  const [spokeAnswer, setSpokeAnswer] = useState("");
  const [spokeScore, setSpokeScore] = useState("");
  const [bladeAnswers, setBladeAnswers] = useState([]);
  const [bladeScores, setBladeScores] = useState([]);
  const location = useLocation();
  const selectedThemeData = location.state?.data || [];
  const selectedTheme = location.state?.theme || '';
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [totalTime, setTotalTime] = useState(null);
  const navigate = useNavigate();

  //////////////Api Integration/////////
  const sendPromptToAPI = async (prompt, label = "") => {
  const maxRetries = 5;
  let retryCount = 0;
  let delay = 1000;

  while (retryCount < maxRetries) {
    try {
      const response = await fetch(API.OPENAI_API, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ prompt }),
      });

      if (response.status === 429) {
        console.log(`[${label}] Rate limited. Retrying in ${delay}ms...`);
        await new Promise((resolve) => setTimeout(resolve, delay));
        retryCount++;
        delay *= 2;
      } else if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          `API Error (${response.status}): ${
            errorData.error || "Unknown error"
          }`
        );
      } else {
        const data = await response.json();
        return data.choices[0].message.content.trim();
      }
    } catch (error) {
      console.error(`[${label}] Error:`, error.message);
      await new Promise((resolve) => setTimeout(resolve, delay));
      retryCount++;
      delay *= 2;
    }
  }

  throw new Error(`[${label}] Failed after ${maxRetries} retries`);
};

  const delay = (ms) => new Promise(res => setTimeout(res, ms));

  const handleSubmit = async () => {
    try {
      const bladeResults = [];
      for (let i = 0; i < bladeAnswers.length; i++) {
        const prompt = `Give a score out of 10 for the answer: "${bladeAnswers[i]}" to the question "${bladeNames[i]}"`;
        const result = await sendPromptToAPI(prompt, `blade-${i}`);
        bladeResults.push(result);
        await delay(2000); // Delay per blade
      }
      setBladeScores(bladeResults);
    } catch (error) {
      console.error("Submission failed:", error.message);
      alert(`Error: ${error.message}`);
    }
  };  

  useEffect(() => {
    const handleAnimationEnd = async () => {
      setShowButtons(true);
      await fetchVajraData();
      await fetchAshokData();
    };

    const node = chakraRef.current;
    if (node) {
      node.addEventListener('animationend', handleAnimationEnd);
    }

    return () => {
      if (node) {
        node.removeEventListener('animationend', handleAnimationEnd);
      }
    };
  }, []);

  const getRandomElement = (arr, count = 1) => {
    const shuffled = [...arr].sort(() => 0.5 - Math.random());
    return count === 1 ? shuffled[0] : shuffled.slice(0, count);
  };

  const fetchVajraData = async () => {
    try {
      const response = await axios.get(API.GET_VAJRACHAKRA_API);
      const names = response.data?.map(item => item.meaning) || [];
      setVajraName(getRandomElement(names));
    } catch (error) {
      console.error('Error fetching Vajrachakra data:', error);
    }
  };
  
  const fetchAshokData = async () => {
    try {
      // Already filtered based on theme from ChakraForm
      const spokes = selectedThemeData.filter(item => item.spoke).map(item => item.spoke);
      const blades = selectedThemeData.filter(item => item.blade).map(item => item.blade);
  
      const uniqueSpokes = [...new Set(spokes)];
      const uniqueBlades = [...new Set(blades)];
  
      setSpokeName(getRandomElement(uniqueSpokes));
      setBladeNames(getRandomElement(uniqueBlades, 4));
    } catch (error) {
      console.error("Error setting themed Ashok data:", error);
    }
  };   

  const handleVajraSubmit = async () => {
    try {
      const vajraPrompt = `Give a score out of 10 for the answer: "${vajraAnswer}" to the question "What do you understand by ${vajraName}?"`;
      const vajraResult = await sendPromptToAPI(vajraPrompt, "vajra");
      setVajraScore(vajraResult);
    } catch (error) {
      console.error("Vajra submission failed:", error.message);
      alert(`Error: ${error.message}`);
    }
  };
  
  const handleSpokeSubmit = async () => {
    try {
      const spokePrompt = `Give a score out of 10 for the answer: "${spokeAnswer}" to the question "${spokeName}"`;
      const spokeResult = await sendPromptToAPI(spokePrompt, "spoke");
      setSpokeScore(spokeResult);
    } catch (error) {
      console.error("Spoke submission failed:", error.message);
      alert(`Error: ${error.message}`);
    }
  };
  
useEffect(() => {
  const handleAnimationEnd = async () => {
    setStartTime(Date.now());
    setShowButtons(true);
    await fetchVajraData();
    await fetchAshokData();
  };
}, []);

const handleFinalSubmit = async () => {
  setEndTime(Date.now());
  const duration = Math.round((Date.now() - startTime) / 1000); // seconds
  setTotalTime(duration);
  await storeGameData(duration);
};

const storeGameData = async (duration) => {
  try {
    const payload = {
      theme: selectedTheme,
      vajraQuestion: `What do you understand by ${vajraName}?`,
      vajraAnswer,
      vajraScore,
      spokeQuestion: spokeName,
      spokeAnswer,
      spokeScore,
      bladeData: bladeNames.map((name, idx) => ({
        question: name,
        answer: bladeAnswers[idx],
        score: bladeScores[idx],
      })),
      timeTaken: duration,
      timestamp: new Date().toISOString(),
    };

    await axios.post(API.SAVE_GAMEDATA, payload);
    alert("Game data saved successfully!");
  } catch (err) {
    console.error("Error storing game data:", err.message);
    alert("Failed to store game data.");
  }
};

  return (
    <div className="min-h-screen flex flex-col bg-white px-5 py-5 ">

    {/* Buttons on Left Side */}
{showButtons && (
  <div className="absolute left-10 flex flex-col gap-4 z-40 text-white">
 {/* Refresh Button in Top-Right */}
 <button
    className="absolute top-0 left-0 bg-red-600 text-white px-3 py-1 rounded hover:bg-red-800 z-50"
    onClick={() => window.location.reload()}
  >
    Refresh
  </button>

   <button
    className="absolute top-0 right-0 bg-red-600 text-white px-3 py-1 rounded hover:bg-red-800 z-50"
    onClick={() => navigate('/chakramaster')}
  >
    Go Back
  </button>

  {/* Vajra + Ashok in a row */}
  <div className="flex flex-row gap-6 mt-6">

    {/* Vajrachakra */}
    <div className="bg-green-800 px-4 py-2 mt-4 rounded shadow-lg w-1/2">
      <div>Vajrachakra</div>
      <div className="text-sm mt-1">Question: What do you understand by {vajraName}?</div>
      <textarea
        rows={3}
        className="w-full mt-2 p-1 text-black text-sm rounded resize-none"
        placeholder="Type your answer..."
        value={vajraAnswer}
        onChange={(e) => setVajraAnswer(e.target.value)}
      />
      <button
    className="mt-2 bg-white text-black text-sm px-3 py-1 rounded hover:bg-green-700 hover:text-white transition"
    onClick={handleVajraSubmit}
  >
    View Score
  </button>
  {vajraScore && (
        <div className="text-xs mt-1 text-green-200">Score: {vajraScore}</div>
      )}
    </div>

    {/* Ashok Chakra */}
    <div className="bg-blue-800 px-4 py-2 mt-4 rounded shadow-lg w-1/2">
      <div>Ashok Chakra</div>
      <div className="text-sm mt-1">Spoke Question: {spokeName}</div>
      <textarea
        rows={3}
        className="w-full mt-2 p-1 text-black text-sm rounded resize-none"
        placeholder="Type your answer..."
        value={spokeAnswer}
        onChange={(e) => setSpokeAnswer(e.target.value)}
      />
      <button
    className="mt-2 bg-white text-black text-sm px-3 py-1 rounded hover:bg-blue-700 hover:text-white transition"
    onClick={handleSpokeSubmit}
  >
    View Score
  </button> 
  {spokeScore && (
        <div className="text-xs mt-1 text-green-200">Score: {spokeScore}</div>
      )}
    </div>
  </div>

  {/* Sudarshan Chakra */}
  <div className="bg-yellow-600 px-4 py-2 rounded shadow-lg mt-2">
    <div>Sudarshan Chakra</div>
    <div className="text-sm">Blade Questions:</div>
    <ul className="text-xs list-disc ml-4 mt-1">
      {bladeNames.map((blade, idx) => (
        <li key={idx} className="mb-2">
          {blade}
          <textarea
            rows={3}
            className="w-full mt-1 p-1 text-black text-xs rounded resize-none"
            placeholder="Your answer..."
            value={bladeAnswers[idx] || ""}
            onChange={(e) => {
              const updatedAnswers = [...bladeAnswers];
              updatedAnswers[idx] = e.target.value;
              setBladeAnswers(updatedAnswers);
            }}
          />
          {bladeScores[idx] && (
            <div className="text-xs mt-1 text-green-200">
              Score: {bladeScores[idx]}
            </div>
          )}
        </li>
      ))}
    </ul>
    <button
      className="mt-4 bg-white text-black text-sm px-4 py-1 rounded hover:bg-yellow-600 transition"
      onClick={handleSubmit}
    >
      View Score
    </button> 
  </div>
   <div className="mt-4 text-center">
    <button
      className="bg-purple-700 text-white text-sm px-4 py-2 rounded hover:bg-purple-900 transition"
      onClick={handleFinalSubmit}
    >
      Submit Game & Save Data
    </button>
    {totalTime && (
      <div className="text-xs mt-2 text-green-200">
        Total Time: {totalTime} seconds
      </div>
    )}
  </div>
</div>
)}

      {/* Chakra Animation */}
<div className="ml-auto relative">

  {/* Chakra Image Stack */}
  <div
    ref={chakraRef}
    className="relative w-[600px] h-[600px] animate-multi-spin"
  >
    <img src={yellow} alt="Yellow Chakra" className="absolute top-0 left-0 w-full h-full z-10" />
    <div className="absolute top-1/2 left-1/2 w-[200px] h-[200px] transform -translate-x-1/2 -translate-y-1/2">
      <img src={blue} alt="Blue Chakra" className="w-full h-full" />
    </div>
  </div>

  <div className="absolute top-[calc(40%-40px)] left-1/2 transform -translate-x-1/2 w-[400px] z-20">
    <img src={green} alt="Green Chakra" className="w-full" />
  </div>
</div>

    </div>
  );
};

export default ChakraShow;
